import { authHeader, authHeaderEmptyContentType } from '@/helpers';
import { handleResponse } from './base.service';
import i18n from '../i18n';

function getAll(search: any) {
  const model = {
    PageNumber: search.actualPage,
    PageSize: search.pageRows,
    OrderBy: search.orderBy,
    OrderByAsc: search.orderByAsc
  };

  Object.keys(search.filter).forEach(key => {
    const filter = search.filter[key];

    if (key !== 'startedOn' && key !== 'endedOn' && key !== 'name') {
      (model as any)[key] = filter.map((item: any) => item.key);
    }
  });

  if (search.filter.startedOn) {
    (model as any).startedOn = search.filter.startedOn;
  }

  if (search.filter.endedOn) {
    (model as any).endedOn = search.filter.endedOn;
  }

  if (search.filter.name) {
    (model as any).Name = search.filter.name;
  }

  const requestOptions = {
    method: 'POST',
    headers: authHeader(),
    body: JSON.stringify(model)
  };

  return fetch(`/api/Projects/Search`, requestOptions as any)
    .then(handleResponse)
    .then(response => {
      if (response.headers && response.headers.find((header: any) => header.key === 'x-pagination')) {
        const pagination = JSON.parse(response.headers.find((header: any) => header.key === 'x-pagination').value);
        response.data.totalCount = pagination.TotalCount;
      }

      return response.data;
    });
}

function getById(id: any) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader()
  };

  return fetch(`/api/Projects/${id}`, requestOptions as any)
    .then(handleResponse)
    .then(response => {
      localStorage.setItem('project', JSON.stringify(response.data));

      return response.data;
    });
}

function getProjectAvailableStates(id: any) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader()
  };

  return fetch(`/api/Projects/${id}/availableStates`, requestOptions as any)
    .then(handleResponse)
    .then(response => {
      return response.data;
    });
}

function createProject(newProject: any) {
  const requestOptions = {
    method: 'POST',
    headers: authHeader(),
    body: JSON.stringify(newProject)
  };

  return fetch(`/api/Projects`, requestOptions as any)
    .then(handleResponse)
    .then(response => {
      return response.data;
    });
}

function updateProject(id: number, project: any) {
  const requestOptions = {
    method: 'PUT',
    headers: authHeader(),
    body: JSON.stringify(project)
  };

  return fetch(`/api/Projects/${id}`, requestOptions as any).then(handleResponse);
}

function deleteProject(id: number) {
  const requestOptions = {
    method: 'DELETE',
    headers: authHeader()
  };

  return fetch(`/api/Projects/${id}`, requestOptions as any).then(handleResponse);
}

function sendStatechangeRequest(id: number, stateChangeRequest: any) {
  const requestOptions = {
    method: 'POST',
    headers: authHeader(),
    body: JSON.stringify(stateChangeRequest)
  };

  return fetch(`/api/Projects/${id}/stateRequest`, requestOptions as any)
    .then(handleResponse)
    .then(response => {
      localStorage.setItem('project', JSON.stringify(response.data));

      return response.data;
    });
}

function resolveStateChangeRequest(id: number, stateChangeRequest: any) {
  const requestOptions = {
    method: 'PUT',
    headers: authHeader(),
    body: JSON.stringify(stateChangeRequest)
  };

  return fetch(`/api/Projects/${id}/stateRequest`, requestOptions as any)
    .then(handleResponse)
    .then(response => {
      localStorage.setItem('project', JSON.stringify(response.data));

      return response.data;
    });
}

function exportTo(search: any, columnsToExport: any) {
  let fileName = 'projects.xlsx';

  const model = {
    PageNumber: search.actualPage,
    PageSize: search.pageRows,
    OrderBy: search.orderBy,
    OrderByAsc: search.orderByAsc,
    CultureCode: i18n.locale === 'en' ? 'en-us' : 'cs-cz'
  };

  if (columnsToExport) {
    (model as any).Columns = columnsToExport.map((column: any) => column.code);
  }

  Object.keys(search.filter).forEach(key => {
    const filter = search.filter[key];

    if (key !== 'startedOn' && key !== 'endedOn' && key !== 'name') {
      (model as any)[key] = filter.map((item: any) => item.key);
    }
  });

  if (search.filter.startedOn) {
    (model as any).startedOn = search.filter.startedOn;
  }

  if (search.filter.endedOn) {
    (model as any).endedOn = search.filter.endedOn;
  }

  if (search.filter.name) {
    (model as any).Name = search.filter.name;
  }

  const requestOptions = {
    method: 'POST',
    headers: authHeader(),
    body: JSON.stringify(model)
  };

  fetch(`/api/Projects/Export`, requestOptions as any)
    .then(response => {
      const header = response.headers.get('Content-Disposition') || '';
      const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
      const matches = filenameRegex.exec(header);

      if (matches != null && matches[1]) {
        fileName = matches[1].replace(/['"]/g, '');
      }

      return response.blob();
    })
    .then(blob => {
      const a = document.createElement('a');
      a.href = URL.createObjectURL(blob);
      a.setAttribute('download', fileName);
      a.click();
    });
}

function exportById(id: any, columnsToExport: any) {
  let fileName = `project_${id}.xlsx`;

  const model = {
    CultureCode: i18n.locale === 'en' ? 'en-us' : 'cs-cz'
  };

  if (columnsToExport) {
    (model as any).Columns = columnsToExport.map((column: any) => column.code);
  }

  const requestOptions = {
    method: 'POST',
    headers: authHeader(),
    body: JSON.stringify(model)
  };

  fetch(`/api/Projects/Export/${id}/export`, requestOptions as any)
    .then(response => {
      const header = response.headers.get('Content-Disposition') || '';
      const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
      const matches = filenameRegex.exec(header);

      if (matches != null && matches[1]) {
        fileName = matches[1].replace(/['"]/g, '');
      }

      return response.blob();
    })
    .then(blob => {
      const a = document.createElement('a');
      a.href = URL.createObjectURL(blob);
      a.setAttribute('download', fileName);
      a.click();
    });
}

function getLog(projectId: number, search: any) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader()
  };

  return fetch(
    `/api/Projects/${projectId}/history?PageSize=${search.pageRows}&PageNumber=${search.actualPage}&OrderBy=${search.orderBy}&OrderByAsc=${search.orderByAsc}`,
    requestOptions as any
  )
    .then(handleResponse)
    .then(response => {
      if (response.headers && response.headers.find((header: any) => header.key === 'x-pagination')) {
        const pagination = JSON.parse(response.headers.find((header: any) => header.key === 'x-pagination').value);
        response.data.totalCount = pagination.TotalCount;
      }

      return response.data;
    });
}

function uploadAttachments(projectId: number, files: any) {
  const headers = authHeaderEmptyContentType();

  const formData = new FormData();
  for (const file of files) {
    formData.append('files', file, file.name);
  }

  const requestOptions = {
    method: 'POST',
    headers: headers,
    body: formData
  };

  return fetch(`/api/Projects/${projectId}/attachments`, requestOptions as any).then(handleResponse);
}

function deleteAttachment(projectId: number, id: number) {
  const requestOptions = {
    method: 'DELETE',
    headers: authHeader()
  };

  return fetch(`/api/Projects/${projectId}/attachments/${id}`, requestOptions as any).then(handleResponse);
}

function downloadAttachment(projectId: number, trustedFileName: string, fileName: string, id: number) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader()
  };

  fetch(`/api/Projects/${projectId}/attachments/${id}`, requestOptions as any)
    .then(response => response.blob())
    .then(blob => {
      const a = document.createElement('a');
      a.href = URL.createObjectURL(blob);
      a.setAttribute('download', fileName);
      a.click();
    });
}

export const projectService = {
  getAll,
  getById,
  getProjectAvailableStates,
  createProject,
  updateProject,
  exportTo,
  exportById,
  getLog,
  uploadAttachments,
  deleteAttachment,
  downloadAttachment,
  sendStatechangeRequest,
  resolveStateChangeRequest,
  deleteProject
};
